import { apiFetch } from "../auth/apiClient";

export const notificationsApi = {
  list: ({ cursor, limit = 8, unreadOnly = false } = {}) => {
    const params = new URLSearchParams();
    if (cursor) params.set("cursor", cursor);
    if (limit) params.set("limit", String(limit));
    if (unreadOnly) params.set("unread_only", "true");
    const qs = params.toString();
    return apiFetch(`/api/notifications${qs ? `?${qs}` : ""}`, {
      method: "GET",
      authRequired: true,
    });
  },
  unreadCount: () =>
    apiFetch("/api/notifications/unread-count", {
      method: "GET",
      authRequired: true,
    }),
  markRead: (id) =>
    apiFetch(`/api/notifications/${id}/read`, {
      method: "POST",
      authRequired: true,
      body: {},
    }),
  markAllRead: () =>
    apiFetch("/api/notifications/read-all", {
      method: "POST",
      authRequired: true,
      body: {},
    }),
  remove: (id) =>
    apiFetch(`/api/notifications/${id}`, {
      method: "DELETE",
      authRequired: true,
    }),
};
